<template>
  <div class="privacy-config-box">
    <h3>{{ data.name }}</h3>
    <!--说明-->
    <ul>
      <h4>{{ data.explain }}</h4>
      <li v-for="(item, index) in data.list" :key="index">
        <h5>{{ index + 1 }}、{{ item.title }}</h5>

        <p v-for="(itemtext, i) in item.texts" :key="i">
          {{ index + 1 }}-{{ i + 1 }}、{{ itemtext.text }}
        </p>
      </li>
    </ul>
    <div class="endexplain">
      <h5>{{ data.summary }}</h5>
      <h6>{{ data.end }}</h6>
    </div>
  </div>
</template> 
<script >
export default {
  name: "Privacyconfig",
  data() {
    return {
      data: {
        //数据
        name: "隐私政策",
        explain:
          "本《隐私策略》规定了oopvr.com（以下简称“本网站”）用户处收集、使用、维护和披露信息的方式。为了向您提供服务，我们可能需要（或有时会根据法律规定需要）收集您的个人资料。",
        list: [
          {
            title: "个人身份识别信息",
            texts: [
              {
                text: "我们可能会通过各种方式收集用户的个人身份识别信息，包括但不限于：用户访问我们的网站、在网站上注册账号以及与我们在网站上提供的其他活动、服务、功能或资源等相关的方式。本网站可能会根据不同情况要求用户提供姓名、电子邮件地址和电话号码。用户也可以以匿名方式访问我们的网站。我们收集用户个人身份识别信息的前提是他们自愿向我们提供这些信息。用户随时都可以拒绝提供个人身份识别信息，但这也意味着无法参与某些与本网站有关的活动。",
              },
            ],
          },
          {
            title: "非个人身份识别信息",
            texts: [
              {
                text: "每当用户访问我们的网站，我们可能会收集与用户有关的非个人身份识别信息。非个人身份识别信息可能包括浏览器名称、计算机型号以及与用户连接本网站方式相关的技术信息，比如用户使用的操作系统、互联网服务提供商以及其他类似信息等。",
              },
            ],
          },
          {
            title: "网页浏览器Cookie缓存",
            texts: [
              {
                text: "缓存数据cookies 是一种可以将少量数据储存在您的电脑硬盘或内存中，并且可以从用户电脑中读取数据的技术，允许网站通过读取此数据来为用户提供具体服务。这项技术已经成为现代互联网运行的基本元素。",
              },
              {
                text: "此cookies政策将遵循告知用户系统将对少量数据进行存储和读取数据的需要，让用户意识并且了解到对其浏览器数据的使用，存储量可以从几个字节到几兆字节。",
              },
              {
                text: "此外对浏览网页来说cookies是非常有必要的。本网站使用cookies，是为了方便和允许用户浏览器对网站的使用，收集的信息包括: 第一次访问时间，访问次数，访问的链接或域名，使用的浏览器，屏幕分辨率以及用户的浏览行为。这些cookies被用作网站分析， 允许本网站或是第三方能够知道用户本身的参与度。",
              },
            ],
          },
          {
            title: "“请勿追踪”信号",
            texts: [
              {
                text: "未经您的许可，我们不会收集任何可以确认您身份的信息。",
              },
            ],
          },
          {
            title: "我们如何使用收集到的信息",
            texts: [
              {
                text: "本网站可能会收集和使用用户的个人信息，以达到以下目的：",
              },
              {
                text: "改善客户服务：用户提供的信息有助于我们更有效地响应用户服务请求和支持需求；",
              },
              {
                text: "使用户体验个性化：我们可能会使用汇总信息来了解我们的用户群体如何使用我们网站上提供的服务和资源；",
              },
              {
                text: "改进我们的网站：我们可能会通过用户反馈的信息来提高我们的产品和服务；",
              },
              {
                text: "定期发送电子邮件：我们可能会使用电子邮件地址发送相关信息和补充资料。",
              },
            ],
          },
          {
            title: "我们如何保护您的信息",
            texts: [
              {
                text: "我们会采取适当的数据收集、存储和处理做法以及安全措施，防止未经授权的访问、更改、披露或破坏您存储在我们网站的个人信息、用户名、密码和数据。",
              },
              {
                text: "本网站与其用户之间通过SSL安全通信通道进行敏感和私人数据交换，并通过数字签名进行加密和保护。我们的网站符合PCI漏洞标准，以便为用户创建尽可能安全的环境。",
              },
            ],
          },
          {
            title: "分享您的个人信息",
            texts: [
              {
                text: "我们不会将用户的个人身份识别信息出售、交易或出租给其他方。",
              },
            ],
          },
          {
            title: "被遗忘权",
            texts: [
              {
                text: "如果您想注销账户并删除所有个人身份识别信息，请通过登录用户，使用用户信息下方注销用户功能，或者联系我们oopvr@foxmail.com。请注意，鉴于此要求，我们也将终止您的在本站账户。同时，我们将删除您在本站的一切信息且无法恢复。",
              },
            ],
          },
          {
            title: "法律和危害",
            texts: [
              {
                text: "尽管本《隐私政策》有相反规定，但在我们认为合理且有必要遵守法律、法规、法律程序或政府的要求，保护任何人的安全，解决欺诈、安全或技术问题，或保护我们或用户的权利或财产的情况下，我们可能会保留或披露您的信息。但是，本《隐私政策》中的任何内容均不是为了限制您对政府要求披露您的信息的任何合法抗辩或异议。",
              },
            ],
          },
          {
            title: "本隐私政策的变更",
            texts: [
              {
                text: "本网站有权随时更新本《隐私政策》。更新后，我们将在我们的网站主页上发布通知，修改主页下方的更新日期并向您发送一份电子邮件。我们鼓励用户经常查看此页面的任何变更，以便了解我们如何保护我们收集的个人信息。您承认并同意，您有责任定期查看本《隐私政策》，并清楚变更内容。",
              },
            ],
          },
          {
            title: "您接受这些条款",
            texts: [
              {
                text: "使用本网站即意味着您接受本政策和使用条款。如果您不同意本政策，请不要使用我们的网站。若您在本政策变更发布后继续使用本网站，则视为您接受这些变更。",
              },
            ],
          },
          {
            title: "联系我们",
            texts: [
              {
                text: "如果您对本《隐私政策》、本网站的做法或您在本网站有任何疑问，请通过oopvr@foxmail.com联系我们。",
              },
            ],
          },
        ],
        summary: "本《隐私政策》适用于本网站的所有服务。",
        end: "更新于2019年9月1日",
      },
    };
  },
};
</script>
<style lang='less' scoped>
.privacy-config-box {
  padding: 15px 0;
  margin-top: 20px;
  margin-bottom: 20px;
  width: 100%;
  // min-height: 1550px;
  background-color: rgba(44, 88, 155, 0.1);
  border-radius: 3% 3% 3% 3%;
  box-shadow: 10px 10px 5px #bdbdbd;
  h3 {
    line-height: 50px;
  }
  ul {
    h4 {
      text-align: left;
      text-indent: 40px;
      margin-left: 5px;
    }
    li {
      text-align: left;
      padding-left: 15px;
      margin-top: 20px;
      p {
        margin-top: 10px;
        text-indent: 40px;
        letter-spacing: 1px;
        font-size: 15px;
      }
    }
  }
  .endexplain {
    // right: 50px;
    padding: 30px 30px;
    text-align: right;
   h5 h6{
      margin-right: 20px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/bottonconfig/privacyconfig.vue